import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.section`
  padding-left: ${(props) => props.theme.spacingHalf};
  stroke-linecap: round;

  .st0 {
    fill: none;
    stroke: url(#SVGID_1_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st1 {
    fill: none;
    stroke: url(#SVGID_2_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st2 {
    fill: none;
    stroke: url(#SVGID_3_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st3 {
    fill: none;
    stroke: url(#SVGID_4_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill: none;
    stroke: url(#SVGID_5_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st5 {
    fill: none;
  }
  .st6 {
    font-family: ${(props) => props.theme.smallFont};
    font-size: 11px;
    fill: ${(props) => props.theme.secondaryTextColor};
  }
  .st8 {
    fill: url(#SVGID_6_);
  }
  .st9 {
    fill: url(#SVGID_7_);
  }
  .st10 {
    fill: url(#SVGID_8_);
  }
  .st11 {
    fill: #121212;
  }
  .st12 {
    fill: url(#SVGID_9_);
  }
  .st13 {
    fill: url(#SVGID_10_);
    stroke: #ffffff;
    stroke-width: 7.7e-2;
    stroke-miterlimit: 10;
  }
  .st14 {
    fill: url(#SVGID_11_);
  }
  .st15 {
    fill: url(#SVGID_12_);
    stroke: #ffffff;
    stroke-width: 7.7e-2;
    stroke-miterlimit: 10;
  }
  .st16 {
    fill: url(#SVGID_13_);
    stroke: #ffffff;
    stroke-width: 7.7e-2;
    stroke-miterlimit: 10;
  }
  .st17 {
    fill: url(#SVGID_14_);
  }
  .st18 {
    fill: url(#SVGID_15_);
  }
  .st19 {
    fill: #b5b5b5;
  }
  .st20 {
    fill: none;
    stroke: #2e2e2e;
    stroke-width: 0.3927;
    stroke-miterlimit: 10;
  }
  .st21 {
    fill: #5c5c5c;
  }
  .st22 {
    fill: #adadad;
  }
  .st23 {
    fill: #707070;
  }
  .st24 {
    fill: none;
    stroke: #333333;
    stroke-width: 0.2946;
    stroke-miterlimit: 10;
  }
  .st25 {
    fill: #d4d4d4;
  }
  .st26 {
    fill: #c9c9c9;
  }
  .st27 {
    fill: #666666;
  }
  .st28 {
    fill: none;
    stroke: #e3e3e3;
    stroke-width: 0.9016;
    stroke-miterlimit: 10;
  }
  .st29 {
    fill: #999999;
  }
  .st30 {
    fill: #6b6b6b;
  }
  .st31 {
    fill: none;
    stroke: #bababa;
    stroke-width: 0.4508;
    stroke-miterlimit: 10;
  }
  .st32 {
    fill: none;
    stroke: #bababa;
    stroke-width: 0.9016;
    stroke-miterlimit: 10;
  }
  .st33 {
    fill: none;
    stroke: #949494;
    stroke-miterlimit: 10;
  }
  .st34 {
    fill: none;
    stroke: #cfcfcf;
    stroke-width: 1.1322;
    stroke-miterlimit: 10;
  }
  .st35 {
    fill: #4968ad;
  }
  .st36 {
    fill: #f24141;
  }
  .st37 {
    fill: none;
    stroke: url(#SVGID_16_);
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st39 {
    fill: ${(props) => props.theme.backgroundColor};
    stroke: url(#SVGID_18_);
    stroke-width: 2;
    stroke-miterlimit: 10;
  }
  .st48 {
    fill: ${(props) => props.theme.backgroundColor};
    stroke: url(#SVGID_27_);
    stroke-width: 2;
    stroke-miterlimit: 10;
  }
`;

const Timeline360Video = () => (
  <Wrapper>
    <svg version="1.1" width="100%" viewBox="0 0 473 167">
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="50.9242"
        y1="130.5356"
        x2="122.3201"
        y2="130.5356"
        gradientTransform="matrix(1 0 0 -1 0 230.1245)"
      >
        <stop offset="0" style={{ stopColor: '#BF8CFF' }} />
        <stop offset="1" style={{ stopColor: '#78D2EB' }} />
      </linearGradient>
      <path
        className="st0"
        d="M50.9,116.2c0,0,26.7,0,48.2,0S104.6,83,122.3,83"
      />
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="50.9242"
        y1="83.007"
        x2="395.3793"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#3FD1FF' }} />
        <stop offset="1" style={{ stopColor: '#3FD17D' }} />
      </linearGradient>
      <line className="st1" x1="50.9" y1="83" x2="395.4" y2="83" />
      <linearGradient
        id="SVGID_3_"
        gradientUnits="userSpaceOnUse"
        x1="394.9247"
        y1="83.007"
        x2="443.8004"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#AB69FF' }} />
        <stop offset="1" style={{ stopColor: '#F24141' }} />
      </linearGradient>
      <line className="st2" x1="394.9" y1="83" x2="443.8" y2="83" />
      <linearGradient
        id="SVGID_4_"
        gradientUnits="userSpaceOnUse"
        x1="50.9242"
        y1="66.6975"
        x2="395.2417"
        y2="66.6975"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#AB69FF' }} />
      </linearGradient>
      <path
        className="st3"
        d="M50.9,50.7c0,0,26.7,0,48.2,0s5.4,33.2,23.2,33.2s5-34.4,24.4-34.4c22.9,0,203.6,0,223.4,0s9.3,33.1,25.1,33.1"
      />
      <linearGradient
        id="SVGID_5_"
        gradientUnits="userSpaceOnUse"
        x1="51.37"
        y1="116.8759"
        x2="396.6894"
        y2="116.8759"
      >
        <stop offset="0" style={{ stopColor: '#FF9F8D' }} />
        <stop offset="1" style={{ stopColor: '#C699FF' }} />
      </linearGradient>
      <path
        className="st4"
        d="M51.4,149.5c0,0,279.6,1.2,295,1.2c39.8,0,23.5-67.7,50.3-67.7"
      />
      <rect x="27.8" y="22.7" className="st5" width="46.2" height="13.7" />
      <text transform="matrix(1 0 0 1 34.9343 31.5867)" className="st6 st7">
        stitch
      </text>
      <rect x="61.3" y="22.7" className="st5" width="46.2" height="13.7" />
      <text transform="matrix(1 0 0 1 73.7385 31.5867)" className="st6 st7">
        edit
      </text>
      <rect x="99.2" y="34.7" className="st5" width="46.2" height="13.7" />
      <text transform="matrix(1 0 0 1 109.2882 43.6167)" className="st6 st7">
        sync
      </text>
      <rect x="135" y="7.6" className="st5" width="61" height="30.5" />
      <text transform="matrix(1 0 0 1 151.6291 16.448)">
        <tspan x="0" y="0" className="st6 st7">
          color{' '}
        </tspan>
        <tspan x="-2.1" y="16" className="st6 st7">
          grade
        </tspan>
      </text>
      <rect x="247.1" y="22.7" className="st5" width="76.7" height="13.7" />
      <text transform="matrix(1 0 0 1 260.9455 31.5867)" className="st6 st7">
        de-noise
      </text>
      <rect x="187.1" y="22.7" className="st5" width="76.7" height="13.7" />
      <text transform="matrix(1 0 0 1 196.7326 31.5867)" className="st6 st7">
        re-sample
      </text>
      <rect x="307.1" y="22.7" className="st5" width="76.7" height="13.7" />
      <text transform="matrix(1 0 0 1 316.7336 31.5867)" className="st6 st7">
        re-sample
      </text>
      <rect x="356.6" y="34.9" className="st5" width="76.7" height="13.7" />
      <text transform="matrix(1 0 0 1 374.5914 43.7751)" className="st6 st7">
        encode
      </text>
      <rect x="142.9" y="97.2" className="st5" width="46.2" height="13.7" />
      <text transform="matrix(1 0 0 1 156.1558 106.0693)" className="st6 st7">
        mix
      </text>
      <rect x="323.7" y="97.2" className="st5" width="46.2" height="13.7" />
      <text transform="matrix(1 0 0 1 334.4982 106.0693)" className="st6 st7">
        limit
      </text>
      <rect x="182.6" y="97.2" className="st5" width="78.5" height="13.7" />
      <text transform="matrix(1 0 0 1 194.3667 106.0693)" className="st6 st7">
        compress
      </text>
      <rect x="250.9" y="97.2" className="st5" width="78.5" height="13.7" />
      <text transform="matrix(1 0 0 1 263.7316 106.0693)" className="st6 st7">
        maximize
      </text>
      <g>
        <linearGradient
          id="SVGID_6_"
          gradientUnits="userSpaceOnUse"
          x1="14.6667"
          y1="44.5782"
          x2="16.8101"
          y2="59.4032"
        >
          <stop offset="0.4096" style={{ stopColor: '#2B2B2B' }} />
          <stop offset="0.5156" style={{ stopColor: '#5B5B5B' }} />
          <stop offset="0.6166" style={{ stopColor: '#242424' }} />
          <stop offset="0.7604" style={{ stopColor: '#1A1A1A' }} />
        </linearGradient>
        <path
          className="st8"
          d="M17.7,52c-0.4-1.6-1.9-2.7-3.6-2.7c-2,0-3.7,1.7-3.7,3.7c0,0.1,0,0.1,0,0.2c-0.5,0.3-0.8,0.7-0.8,1.1
		c0,0.2,0,1,0,1.2c0,1.3,2.9,2.3,6.5,2.3s6.5-1,6.5-2.3c0-0.2,0-1,0-1.2C22.6,53.2,20.5,52.3,17.7,52z"
        />
        <radialGradient
          id="SVGID_7_"
          cx="13.2246"
          cy="37.4707"
          r="25.7182"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="2.996679e-02" style={{ stopColor: '#5C5C5C' }} />
          <stop offset="0.4665" style={{ stopColor: '#2E2E2E' }} />
        </radialGradient>
        <path
          className="st9"
          d="M28.8,38.1c0-3.2-1.4-6.2-3.7-8.3l-2-0.7l-2.1-1.8c-1.5-0.6-3.1-0.9-4.8-0.9c-7,0-12.6,5.2-12.6,11.7
		c0,5.6,4.3,10.3,10,11.4c-0.4,0.1-0.6,0.2-0.6,0.4c0,0.4,1.3,0.7,3,0.7s3-0.3,3-0.7c0-0.1-0.2-0.2-0.4-0.3
		C24.3,48.5,28.8,43.8,28.8,38.1z"
        />
        <linearGradient
          id="SVGID_8_"
          gradientUnits="userSpaceOnUse"
          x1="15.2382"
          y1="33.1369"
          x2="16.0419"
          y2="45.5506"
        >
          <stop offset="0" style={{ stopColor: '#404040' }} />
          <stop offset="1" style={{ stopColor: '#121212' }} />
        </linearGradient>
        <ellipse className="st10" cx="15.8" cy="42.1" rx="3.9" ry="3.3" />
        <g>
          <path
            className="st11"
            d="M15.8,44.6c-1.6,0-2.8-1.1-2.8-2.4s1.3-2.4,2.8-2.4s2.8,1.1,2.8,2.4S17.3,44.6,15.8,44.6z"
          />
          <path
            d="M15.8,39.8c1.5,0,2.8,1.1,2.8,2.4s-1.3,2.4-2.8,2.4S13,43.5,13,42.2S14.2,39.8,15.8,39.8 M15.8,39.8
			c-1.6,0-2.8,1.1-2.8,2.4c0,1.3,1.3,2.4,2.8,2.4c1.6,0,2.8-1.1,2.8-2.4C18.6,40.9,17.4,39.8,15.8,39.8L15.8,39.8z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_9_"
            gradientUnits="userSpaceOnUse"
            x1="25.0647"
            y1="39.5424"
            x2="28.7708"
            y2="39.5424"
          >
            <stop offset="0" style={{ stopColor: '#404040' }} />
            <stop offset="1" style={{ stopColor: '#121212' }} />
          </linearGradient>
          <path
            className="st12"
            d="M28.7,36.9c-0.2-0.3-0.4-0.6-0.7-0.7c-1-0.3-2.2,1-2.7,2.9c-0.5,1.8-0.2,3.6,0.8,3.8
			c0.7,0.2,1.6-0.5,2.2-1.7c0.3-1,0.5-2.1,0.5-3.2C28.8,37.7,28.7,37.3,28.7,36.9z"
          />
          <g>
            <path
              className="st11"
              d="M26.6,42.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.6-0.4-0.7-1c-0.1-0.5,0-1.2,0.1-1.9C26.2,38,27,37,27.7,37
				c0.1,0,0.1,0,0.2,0c0.3,0.1,0.6,0.4,0.7,1c0.1,0.5,0,1.2-0.1,1.9C28,41.2,27.2,42.2,26.6,42.2z"
            />
            <g>
              <path
                d="M27.7,37L27.7,37c0.1,0,0.1,0,0.2,0.1c0.7,0.2,0.9,1.5,0.5,2.9c-0.4,1.3-1.1,2.2-1.8,2.2c-0.1,0-0.1,0-0.2,0
					c-0.7-0.2-0.9-1.5-0.5-2.9C26.3,38,27,37.1,27.7,37L27.7,37 M27.7,37c-0.7,0-1.4,0.9-1.8,2.2c-0.4,1.4-0.2,2.7,0.5,2.9
					c0.1,0,0.1,0,0.2,0c0.7,0,1.4-0.9,1.8-2.2c0.4-1.4,0.2-2.7-0.5-2.9C27.8,37,27.7,37,27.7,37L27.7,37z"
              />
            </g>
          </g>
          <linearGradient
            id="SVGID_10_"
            gradientUnits="userSpaceOnUse"
            x1="26.7009"
            y1="39.698"
            x2="28.0577"
            y2="39.698"
          >
            <stop offset="0.4395" style={{ stopColor: '#000000' }} />
            <stop offset="0.5927" style={{ stopColor: '#707070' }} />
            <stop offset="1" style={{ stopColor: '#1A1A1A' }} />
          </linearGradient>
          <path
            className="st13"
            d="M28,39.9c-0.2,0.6-0.6,0.9-0.9,0.9c-0.3-0.1-0.5-0.6-0.3-1.2c0.2-0.6,0.6-0.9,0.9-0.9
			C28,38.8,28.2,39.3,28,39.9z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_11_"
            gradientUnits="userSpaceOnUse"
            x1="788.2283"
            y1="40.3862"
            x2="791.6602"
            y2="40.3862"
            gradientTransform="matrix(-1 0 0 1 795.4119 0)"
          >
            <stop offset="0" style={{ stopColor: '#404040' }} />
            <stop offset="1" style={{ stopColor: '#121212' }} />
          </linearGradient>
          <path
            className="st14"
            d="M3.8,37.7C4,37.3,4.2,37.1,4.5,37c0.9-0.3,2,1,2.5,2.9c0.5,1.9,0.2,3.6-0.7,3.9c-0.7,0.2-1.5-0.5-2-1.7
			c-0.3-1-0.4-2.1-0.4-3.2C3.8,38.5,3.8,38.1,3.8,37.7z"
          />
          <g>
            <path
              className="st11"
              d="M5.8,43.1c-0.6,0-1.3-1-1.6-2.3c-0.4-1.4-0.2-2.8,0.5-3c0.1,0,0.1,0,0.2,0c0.6,0,1.3,1,1.6,2.3
				c0.4,1.4,0.2,2.8-0.5,3C5.9,43.1,5.8,43.1,5.8,43.1L5.8,43.1z"
            />
            <g>
              <path
                d="M4.8,37.8c0.6,0,1.3,1,1.6,2.3c0.4,1.4,0.2,2.7-0.5,2.9c0,0-0.1,0-0.2,0c-0.6,0-1.3-1-1.6-2.3c-0.4-1.4-0.2-2.7,0.5-2.9
					C4.7,37.9,4.7,37.8,4.8,37.8 M4.8,37.8c-0.1,0-0.1,0-0.2,0c-0.6,0.2-0.9,1.5-0.5,3c0.3,1.3,1,2.3,1.7,2.3c0.1,0,0.1,0,0.2,0
					c0.6-0.2,0.9-1.5,0.5-3C6.1,38.8,5.4,37.8,4.8,37.8L4.8,37.8z"
              />
            </g>
          </g>

          <linearGradient
            id="SVGID_12_"
            gradientUnits="userSpaceOnUse"
            x1="802.5759"
            y1="150.1357"
            x2="804.1321"
            y2="150.1357"
            gradientTransform="matrix(-0.8074 0 0 0.8928 653.6536 -93.4919)"
          >
            <stop offset="0.4395" style={{ stopColor: '#000000' }} />
            <stop offset="0.5927" style={{ stopColor: '#707070' }} />
            <stop offset="1" style={{ stopColor: '#1A1A1A' }} />
          </linearGradient>
          <path
            className="st15"
            d="M4.5,40.7c0.1,0.6,0.5,1,0.8,0.9c0.3-0.1,0.4-0.6,0.3-1.2s-0.5-1-0.8-0.9C4.5,39.6,4.3,40.1,4.5,40.7z"
          />
        </g>
        <linearGradient
          id="SVGID_13_"
          gradientUnits="userSpaceOnUse"
          x1="15.0127"
          y1="43.259"
          x2="17.8668"
          y2="39.35"
        >
          <stop offset="0.4395" style={{ stopColor: '#000000' }} />
          <stop offset="0.5927" style={{ stopColor: '#707070' }} />
          <stop offset="1" style={{ stopColor: '#1A1A1A' }} />
        </linearGradient>
        <ellipse className="st16" cx="15.8" cy="42.2" rx="1.4" ry="1.2" />
        <linearGradient
          id="SVGID_14_"
          gradientUnits="userSpaceOnUse"
          x1="17.0932"
          y1="22.2318"
          x2="5.0368"
          y2="42.9957"
        >
          <stop offset="0.4692" style={{ stopColor: '#212121' }} />
          <stop offset="0.5956" style={{ stopColor: '#404040' }} />
          <stop offset="0.7212" style={{ stopColor: '#121212' }} />
        </linearGradient>
        <path
          className="st17"
          d="M4.4,33.9c0.5,0.6,1.1,1.2,1.8,1.5c1.5,0.8,6.7,1.2,7.5,1.2c1.2-0.1,1.8-0.9,1.7-1.8s-1.9-5.6-4.2-6.3
		c-0.9-0.3-2-0.1-3,0.4C6.5,30.2,5.2,31.9,4.4,33.9z"
        />
      </g>
      <g>
        <linearGradient
          id="SVGID_15_"
          gradientUnits="userSpaceOnUse"
          x1="155.9342"
          y1="111.7997"
          x2="173.9108"
          y2="111.4698"
          gradientTransform="matrix(0.7071 -0.7071 0.7071 0.7071 -185.0873 124.9477)"
        >
          <stop offset="0.1991" style={{ stopColor: '#C9C9C9' }} />
          <stop offset="0.4395" style={{ stopColor: '#2E2E2E' }} />
          <stop offset="0.5927" style={{ stopColor: '#969696' }} />
          <stop offset="0.7823" style={{ stopColor: '#404040' }} />
          <stop offset="1" style={{ stopColor: '#1A1A1A' }} />
        </linearGradient>
        <path
          className="st18"
          d="M4.6,68.8L4.6,68.8c-7,7,0.5,10.3,2.8,11.7c2.3,1.4,8.4,6.8,8.4,6.8l8.4,8.6l1.8-0.3l2.7-2.5l0.1-0.1l2.5-2.6
		l0.3-1.8L23,80c0,0-5.4-6.2-6.8-8.4C14.8,69.3,11.4,61.9,4.6,68.8z M9.8,74.2c-0.3,0.3-1.7,2.1-1.7,2.1s-0.7-1.6-0.8-1.9
		c-0.1-0.3,0.6-2.8,0.6-2.8l3.9,1C11.8,72.7,10.1,73.9,9.8,74.2z M12.7,68.9l-0.1,0.3l-1.2,0.9c0,0-2.8,1.3-3.6,0.6l-0.1,0.1
		C7.5,71.9,5.5,75,5.5,75l-0.5,2.1c0,0-1.2-0.6-1.9-2.2c-0.7-1.6,0.2-3.8,1.8-5.3c1.5-1.4,3.3-2.6,4.9-2.4
		C11.4,67.4,12.7,68.9,12.7,68.9z"
        />
        <path
          className="st19"
          d="M6.1,72.7c0.2,0,5.6,0,5.7,0s0.3-3.1,0.1-3.1c-0.1,0-5.3,0-5.7,0S5.9,72.7,6.1,72.7z"
        />
        <line className="st20" x1="9.8" y1="69.6" x2="9.8" y2="72.7" />
        <line className="st20" x1="9" y1="69.6" x2="9" y2="72.7" />
        <line className="st20" x1="8.2" y1="69.6" x2="8.2" y2="72.7" />
        <polygon
          className="st21"
          points="12.7,76.1 15.8,73.4 16.5,73.4 21.2,78.9 21.2,80.3 16,85.5 14.6,85.5 9.1,80.8 9.1,80.1 11.8,77 	
		"
        />

        <rect
          x="11.2"
          y="76.9"
          transform="matrix(0.7071 -0.7071 0.7071 0.7071 -51.8127 34.251)"
          className="st22"
          width="8.5"
          height="5.6"
        />
        <circle className="st23" cx="21.4" cy="85.6" r="1.3" />
        <polygon
          className="st24"
          points="22.1,89.9 21.7,89.9 20.9,89.1 20.9,88.8 22.2,87.5 22.6,87.5 23.4,88.3 23.4,88.7 	"
        />
        <polygon
          className="st24"
          points="23.6,91.4 23.2,91.4 22.5,90.7 22.5,90.4 23.8,89.1 24.2,89.1 24.8,89.7 24.8,90.1 	"
        />
        <polygon
          className="st24"
          points="24.4,87.6 24.1,87.6 23.3,86.8 23.3,86.4 24.5,85.1 24.9,85.1 25.7,86 25.7,86.3 	"
        />
        <polygon
          className="st24"
          points="25.9,89.1 25.5,89.1 24.9,88.4 24.9,88.1 26.2,86.8 26.5,86.8 27.2,87.4 27.2,87.8 	"
        />
        <circle className="st25" cx="19.8" cy="87.1" r="0.3" />
        <path
          className="st26"
          d="M8.3,70.5c0,0.2,0,5.6,0,5.7c0,0.1-3.1,0.3-3.1,0.1c0-0.1,0-5.3,0-5.7C5.2,70.2,8.3,70.3,8.3,70.5z"
        />
        <line className="st20" x1="5.2" y1="74.2" x2="8.3" y2="74.2" />
        <line className="st20" x1="5.2" y1="73.4" x2="8.3" y2="73.4" />
        <line className="st20" x1="5.2" y1="72.6" x2="8.3" y2="72.6" />
        <circle className="st27" cx="11.4" cy="75.6" r="1.9" />
      </g>
      <g>
        <line className="st28" x1="18.5" y1="130.2" x2="33.4" y2="115.2" />
        <g>
          <path
            className="st29"
            d="M16.1,130c0,0,0.5-1.5,0.6-1.9c0.1-0.3,0.5-0.8,0.5-0.8s0.9-0.3,1.6-0.9c0.7-0.6,2.2-3.2,2.2-3.2l3.4,2
			c0,0-1,2.4-1.9,3c-0.8,0.6-2.1,1.3-2.1,1.3l-0.7,2.7L16.1,130z"
          />
          <polygon
            className="st30"
            points="24.4,125.1 24.9,126.3 19.8,132.1 20.5,129.4 		"
          />
          <line className="st31" x1="19.2" y1="126.1" x2="21.8" y2="127.6" />
          <line className="st31" x1="20.1" y1="125.1" x2="22.7" y2="126.6" />
          <line className="st31" x1="21" y1="123.7" x2="23.8" y2="125.3" />
          <line className="st31" x1="18.4" y1="127" x2="21" y2="128.5" />
          <line className="st32" x1="16.9" y1="128.3" x2="20" y2="130" />
        </g>
        <line className="st28" x1="12.6" y1="124.3" x2="27.6" y2="109.4" />
        <g>
          <path
            className="st29"
            d="M16.8,118.2c0,0,0.5-1.5,0.6-1.9c0.1-0.3,0.5-0.8,0.5-0.8s0.9-0.3,1.6-0.9c0.7-0.6,2.2-3.2,2.2-3.2l3.4,2
			c0,0-1,2.4-1.9,3c-0.8,0.6-2.1,1.3-2.1,1.3l-0.7,2.7L16.8,118.2z"
          />
          <polygon
            className="st30"
            points="25.1,113.4 25.6,114.6 20.5,120.4 21.2,117.7 		"
          />
          <line className="st31" x1="20" y1="114.3" x2="22.5" y2="115.8" />
          <line className="st31" x1="20.8" y1="113.4" x2="23.4" y2="114.9" />
          <line className="st31" x1="21.7" y1="112" x2="24.5" y2="113.6" />
          <line className="st31" x1="19.1" y1="115.3" x2="21.7" y2="116.8" />
          <line className="st32" x1="17.6" y1="116.5" x2="20.7" y2="118.2" />
        </g>
        <line className="st28" x1="6.8" y1="118.5" x2="21.7" y2="103.5" />
        <g>
          <path
            className="st29"
            d="M6.5,115.6c0,0,0.5-1.5,0.6-1.9c0.1-0.3,0.5-0.8,0.5-0.8s0.9-0.3,1.6-0.9s2.2-3.2,2.2-3.2l3.4,2
			c0,0-1,2.4-1.9,3c-0.8,0.6-2.1,1.3-2.1,1.3l-0.7,2.7L6.5,115.6z"
          />
          <polygon
            className="st30"
            points="14.9,110.7 15.4,111.9 10.2,117.7 10.9,115 		"
          />
          <line className="st31" x1="9.7" y1="111.7" x2="12.3" y2="113.2" />
          <line className="st31" x1="10.5" y1="110.7" x2="13.1" y2="112.2" />
          <line className="st31" x1="11.5" y1="109.3" x2="14.2" y2="110.9" />
          <line className="st31" x1="8.9" y1="112.6" x2="11.4" y2="114.1" />
          <line className="st32" x1="7.4" y1="113.9" x2="10.4" y2="115.6" />
        </g>
      </g>
      <g>
        <rect x="6.5" y="142.6" className="st33" width="21.2" height="17.7" />
        <g>
          <path
            className="st34"
            d="M15.1,154.5c0,0,2.1-2.9,6.3-2.9c5.2,0,5.2,3.7,10,3.7s6.4-5.8,6.4-5.8"
          />
          <rect x="20.1" y="150.3" className="st33" width="2.6" height="2.6" />
          <rect x="30.5" y="153.9" className="st33" width="2.6" height="2.6" />
        </g>
        <g>
          <path d="M12.8,147.3H9.3v-2.1h9.5v2.1h-3.5v9.9h-2.4V147.3z" />
        </g>
      </g>
      <g>
        <path
          className="st35"
          d="M464.5,45c0,0.8,0,1.7,0,2.5c-1,0-2,0-3.1,0c0,2.5,0,5.1,0,7.7c-1,0-2,0-3,0c0-2.5,0-5.1,0-7.6
		c-1,0-1.7,0-2.7,0c0-0.8,0-1.7,0-2.5c0.8,0,1.7,0,2.7,0c0-0.7,0-1.4,0-2c0.1-2.1,1.7-3.5,3.7-3.5c0.8,0,1.5,0,2.4,0
		c0,1,0,2.8,0,2.8h-2.1c-0.6,0-0.8,0.3-0.8,0.8s0,1.1,0,1.8C462.4,45,463.4,45,464.5,45z"
        />
      </g>
      <g
        id="g4167_1_"
        transform="matrix(5.9026317,0,0,5.9026317,521.39665,-711.31763)"
      >
        <path
          id="path4156_1_"
          className="st36"
          d="M-10.4,133.5c0,0-1,0-1.2,0.1c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.2-0.1,0.8-0.1,0.8
		s0,0.5,0.1,0.7c0,0.1,0.1,0.2,0.3,0.3c0.2,0.1,1.2,0.1,1.2,0.1s1,0,1.2-0.1c0.1,0,0.2-0.1,0.3-0.3c0.1-0.2,0.1-0.7,0.1-0.7
		s0-0.5-0.1-0.8c0-0.1-0.1-0.2-0.3-0.3C-9.4,133.5-10.4,133.5-10.4,133.5z M-10.7,134.1l0.8,0.5l-0.8,0.5V134.1L-10.7,134.1z"
        />
      </g>
      <linearGradient
        id="SVGID_16_"
        gradientUnits="userSpaceOnUse"
        x1="394.801"
        y1="64.9971"
        x2="443.8004"
        y2="64.9971"
      >
        <stop offset="0" style={{ stopColor: '#AB69FF' }} />
        <stop offset="1" style={{ stopColor: '#4968AD' }} />
      </linearGradient>
      <path
        className="st37"
        d="M394.8,83.1c19.8,0,12.3-36.2,28-36.2c5.1,0,21,0,21,0"
      />
      <linearGradient
        id="SVGID_17_"
        gradientUnits="userSpaceOnUse"
        x1="114.4929"
        y1="83.007"
        x2="130.1473"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#3FD1FF' }} />
        <stop offset="1" style={{ stopColor: '#3FD17D' }} />
      </linearGradient>
      <circle className="st48" cx="122.3" cy="83" r="6.8" />
      <linearGradient
        id="SVGID_18_"
        gradientUnits="userSpaceOnUse"
        x1="157.5796"
        y1="83.007"
        x2="173.2339"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#3FD1FF' }} />
        <stop offset="1" style={{ stopColor: '#3FD17D' }} />
      </linearGradient>
      <circle className="st39" cx="165.4" cy="83" r="6.8" />
      <linearGradient
        id="SVGID_19_"
        gradientUnits="userSpaceOnUse"
        x1="217.5796"
        y1="83.007"
        x2="233.2339"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#3FD1FF' }} />
        <stop offset="1" style={{ stopColor: '#3FD17D' }} />
      </linearGradient>
      <circle className="st39" cx="225.4" cy="83" r="6.8" />
      <linearGradient
        id="SVGID_20_"
        gradientUnits="userSpaceOnUse"
        x1="277.5796"
        y1="83.007"
        x2="293.2339"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#3FD1FF' }} />
        <stop offset="1" style={{ stopColor: '#3FD17D' }} />
      </linearGradient>
      <circle className="st39" cx="285.4" cy="83" r="6.8" />
      <linearGradient
        id="SVGID_21_"
        gradientUnits="userSpaceOnUse"
        x1="337.5796"
        y1="83.007"
        x2="353.2339"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#3FD1FF' }} />
        <stop offset="1" style={{ stopColor: '#3FD17D' }} />
      </linearGradient>
      <circle className="st39" cx="345.4" cy="83" r="6.8" />
      <linearGradient
        id="SVGID_22_"
        gradientUnits="userSpaceOnUse"
        x1="157.6676"
        y1="49.5061"
        x2="173.322"
        y2="49.5061"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="165.5" cy="49.5" r="6.8" />
      <linearGradient
        id="SVGID_23_"
        gradientUnits="userSpaceOnUse"
        x1="217.5796"
        y1="49.5061"
        x2="233.2339"
        y2="49.5061"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="225.4" cy="49.5" r="6.8" />
      <linearGradient
        id="SVGID_24_"
        gradientUnits="userSpaceOnUse"
        x1="277.5796"
        y1="49.5061"
        x2="293.2339"
        y2="49.5061"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="285.4" cy="49.5" r="6.8" />
      <linearGradient
        id="SVGID_25_"
        gradientUnits="userSpaceOnUse"
        x1="337.5796"
        y1="49.5061"
        x2="353.2339"
        y2="49.5061"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="345.4" cy="49.5" r="6.8" />
      <linearGradient
        id="SVGID_26_"
        gradientUnits="userSpaceOnUse"
        x1="389.0975"
        y1="83.007"
        x2="404.7519"
        y2="83.007"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="396.9" cy="83" r="6.8" />
      <linearGradient
        id="SVGID_27_"
        gradientUnits="userSpaceOnUse"
        x1="43.097"
        y1="50.7252"
        x2="58.7514"
        y2="50.7252"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="50.9" cy="50.7" r="6.8" />
      <linearGradient
        id="SVGID_28_"
        gradientUnits="userSpaceOnUse"
        x1="73.097"
        y1="50.7252"
        x2="88.7514"
        y2="50.7252"
      >
        <stop offset="0" style={{ stopColor: '#FF3BB8' }} />
        <stop offset="1" style={{ stopColor: '#8F35FF' }} />
      </linearGradient>
      <circle className="st48" cx="80.9" cy="50.7" r="6.8" />
    </svg>
  </Wrapper>
);

export default Timeline360Video;
